import { render } from "./CopyIcon.svg?vue&type=template&id=df88bd2e"
const script = {}
script.render = render

export default script